module.exports = __webpack_public_path__ + "fa912faf21664e7397c341e5b501d3fd.svg";